module.exports = __webpack_public_path__ + "img/Single vent-1.11b26e80.svg";